/* Tape Unlimited live nav/footer trust-link repair. */
(function() {
  var linkTargets = {
    'About Us': '/pages/about-us',
    'Search Terms': '/search',
    'Contact Us': '/pages/contact-us',
    'Order & Returns': '/pages/shipping-and-refund',
    'Return and refund policy': '/policies/refund-policy',
    'Shipping & Delivery': '/pages/shipping-and-refund',
    'Support': '/pages/contact-us',
    'Terms & Condition': '/policies/terms-of-service',
    'Returns': '/policies/refund-policy',
    'Full Store Directory': '/collections/all',
    'Clearance': '/collections/all'
  };
  var navigationTargets = {
    'SHOP BY BRAND': '/collections/all',
    'Duck Brand': '/search?q=Duck%20Brand&type=product',
    'IPG': '/search?q=IPG&type=product',
    'Nashua': '/search?q=Nashua&type=product',
    'Polyken': '/search?q=Polyken&type=product',
    'Presco': '/collections/vendors?q=Presco',
    'Velcro': '/search?q=Velcro&type=product',
    'Full Store Directory': '/collections/all',
    'Clearance': '/collections/all'
  };
  var topbarTargets = {
    'Delivery': '/pages/shipping-and-refund',
    'Track your order': '/pages/track-your-order'
  };
  var removeTopbar = {
    'Stores': true,
    'Guarantee': true
  };
  var removeFooter = {
    'Customer Service': true,
    'Privacy Policy': true,
    'Our Sitemap': true,
    'Secure Payment': true,
    'Guarantee': true
  };

  function normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  }

  function hasBadHref(link) {
    var href = link.getAttribute('href') || '';
    return href === '#' || href === '/collections' || href === '/collections/' || href.indexOf('arena-chromium.myshopify.com') !== -1;
  }

  function removeLink(link) {
    var node = link;
    while (node && node.tagName !== 'LI') node = node.parentNode;
    if (node && node.parentNode) node.parentNode.removeChild(node);
  }

  function repairLinks(selector, targets, removals) {
    var links = document.querySelectorAll(selector);
    var i;

    for (i = 0; i < links.length; i += 1) {
      var link = links[i];
      var text = normalizeText(link.textContent);

      if (removals[text]) {
        removeLink(link);
      } else if (targets[text] && hasBadHref(link)) {
        link.setAttribute('href', targets[text]);
      }
    }
  }

  function repairTrustLinks() {
    repairLinks('.header-top .topbar-menu a', topbarTargets, removeTopbar);
    repairLinks('.footer-container .footer-menu a', linkTargets, removeFooter);
    repairLinks('.menu-list a, .main-nav a, .menu-mobile a, .categories-section a', navigationTargets, {});
  }

  window.TURepairTrustLinks = repairTrustLinks;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairTrustLinks);
  } else {
    repairTrustLinks();
  }

  setTimeout(repairTrustLinks, 500);
  setTimeout(repairTrustLinks, 1500);
})();
